
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|4001|6995|9879)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
